import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NbAuthJWTInterceptor, NbAuthJWTToken, NbAuthService } from '@nebular/auth';
import { MyAccountsService } from '../services/my-accounts.service';
import { ValuesService } from '../services/values.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.page.html',
  styleUrls: ['./home.page.scss'],
})
export class HomePage implements OnInit {

  constructor(private router: Router,
              private myAccountsService: MyAccountsService,
              public valuesService: ValuesService,) {}

  ngOnInit() {
    console.log('ISLOGGEDIN ' + this.valuesService.ISLOGGEDIN);
    this.myAccountsService.myAccounts();
  }

  ionViewWillEnter() {
    this.myAccountsService.myAccounts();
  }

  newInvoice() {
    this.router.navigate(['/invoices-create-new']);
  }

  listInvoice() {
    this.router.navigate(['/invoices-list']);
  }

}
